<template>
    <div class="unionContent">
        <div class="treeBox flex">
            <div class="treeOne column">
                <div :class="['oneItem column',oneActive == index ? 'oneItemOn' : '']" v-for="(item,index) in leftTab" :key="index" @click="oneActive = index">
                    <el-image :src="item.img" fit="cover" class="oneIcon"></el-image>
                    <div class="oneName">{{ item.name }}</div>
                </div>
            </div>
            <div class="treeTwoBox column">
                <el-image :src="logoImg" fit="contain" class="uniLogo"></el-image>
                <div class="treeTwo">
                    <!-- <el-tree :data="terrData" :props="defaultProps" accordion icon-class=" " @node-click="handleNodeClick">
                        <template #default="{node, data}">
                            <template v-if="node.level === 1">
                                <div class="twoBox align">
                                    <el-image v-if="node.expanded && node.level==1" :src="data.icon" fit="cover" class="twoIcon"></el-image>
                                    <el-image v-else :src="data.img" fit="cover" class="twoIcon"></el-image>
                                    <span :class="['twoName',node.expanded && node.level==1 ? 'twoNameOn' : '']">{{ data.title }}</span>
                                </div>
                            </template>
                            <template v-else-if="node.level === 2">
                                <div class="twoBox align">
                                    <span :class="['twoName',node.isCurrent && node.level==2 ? 'twoNameOn' : '']">{{ data.title }}</span>
                                </div>
                            </template>
                        </template>
                    </el-tree> -->
                    <div class="twoBox align" v-for="(item,index) in terrData" :key="index" @click="twoBoxTap(index)">
                        <el-image :src="treeActive == index ? item.img_sel : item.img" fit="cover" class="twoIcon"></el-image>
                        <span :class="['twoName',treeActive == index ? 'twoNameOn' : '']">{{ item.title }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="unionBox" v-if="terrData.length > 0">
            <div class="unionTop spb">
                <div class="foldBox center">
                    <el-image :src="require('@/assets/icon/fold.png')" fit="cover" class="fold"></el-image>
                </div>
                <div class="floatList align">
                    <div class="floatBox align">
                        <el-image :src="require('@/assets/icon/float01.png')" fit="cover" class="floatIcon"></el-image>
                        <div class="floatName">联系客服</div>
                    </div>
                    <div class="line"></div>
                    <div class="floatBox align">
                        <el-image :src="require('@/assets/icon/float01.png')" fit="cover" class="floatIcon"></el-image>
                        <div class="floatName">活动公告</div>
                    </div>
                    <div class="line"></div>
                    <div class="floatBox align">
                        <el-image :src="require('@/assets/icon/float01.png')" fit="cover" class="floatIcon"></el-image>
                        <div class="floatName">小程序</div>
                    </div>
                    <el-image :src="userData.avatar" fit="cover" class="head"></el-image>
                </div>
            </div>
            <div class="concert column" v-if="terrData[treeActive].name == 'yanchanghui'">
                <el-image :src="unionData.list[0].img" fit="cover" class="concertImg"></el-image>
                <div class="concertContent">
                    <div class="concertBox">
                        <div class="concertTitle">{{ unionData.list[0].title }}</div>
                        <div class="concertTips">{{ unionData.list[0].shuoming }}</div>
                        <div class="concertComm">佣金<span class="concertCommNum">{{ unionData.list[0].yongjin }}</span></div>
                        <div class="concertBtnBox flex">
                            <div class="smBtn" @click="smBtnTap">活动说明</div>
                            <div class="tgBtn" @click="unionBtnTap(unionData.list[0].id)">立即推广</div>
                        </div>
                    </div>
                </div>
                <div class="concertList flex">
                        <div class="concertItem column" v-for="(item,index) in unionData.list[0].list" :key="index">
                            <el-image :src="item.img" fit="cover" class="ciImg"></el-image>
                            <div class="ciTitle" :title="item.title">{{ item.title }}</div>
                            <div class="ciTips" :title="item.desc">{{ item.desc }}</div>
                        </div>
                    </div>
            </div>
            <div class="unionBottom" v-else>
                <div class="groupBox" v-if="terrData[treeActive].name == 'bendi'">
                    <div class="expandBox center" @click="expand = !expand">
                        <div class="expandName">{{ expand ? '收起' : '展开' }}</div>
                        <el-image :src="require(expand ? '@/assets/icon/expandOn.png' : '@/assets/icon/expand.png')" fit="cover" class="expandIcon"></el-image>
                    </div>
                    <div class="groupScreen" v-if="expand">
                        <div class="screenBox flex">
                            <div class="screenTitle">省份：</div>
                            <div class="screenList flex">
                                <div :class="['screen',cityOne == index ? 'screenOn' : '']" v-for="(item,index) in cityData" :key="index" @click="cityOneTap(index)">{{ item.title }}</div>
                            </div>
                        </div>
                        <div class="screenBox flex" v-if="cityData[cityOne]">
                            <div class="screenTitle">城市：</div>
                            <div class="screenList flex">
                                <div :class="['screen',cityTwo == index ? 'screenOn' : '']" v-for="(item,index) in cityData[cityOne].children" :key="index" @click="cityTwoTap(index)">{{ item.title }}</div>
                            </div>
                        </div>
                        <div class="screenBox align">
                            <div class="screenTitle">商品：</div>
                            <el-input v-model="goodSearchKey" placeholder="搜门店 找优惠" class="goodSearch"></el-input>
                            <div class="goodSearchBtn" @click="getGoodsInitial">搜索</div>
                        </div>
                        <div class="screenBox flex">
                            <div class="screenTitle">商品分类：</div>
                            <div class="screenList flex">
                                <div :class="['screen',goodsCateActive == index ? 'screenOn' : '']" v-for="(item,index) in goodsCateData" :key="index" @click="goodsCateTap(index)">{{ item.title }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="groupList flex" v-infinite-scroll="load" style="overflow:auto" :infinite-scroll-distance="1">
                        <div class="group" v-for="(item,index) in goodsData.list" :key="index">
                            <el-image :src="item.item_img" fit="cover" class="groupImg"></el-image>
                            <div class="groupTitle">{{ item.name }}</div>
                            <div class="groupCommission">佣金<span class="groupCommissionNum">{{ item.commission_rate }}</span></div>
                            <div class="flex">
                                <div class="price">{{ item.price }}</div>
                                <div class="origin">￥{{ item.origin_price }}</div>
                                <div class="discount">{{ item.zhekou }}折</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="unionTabBox between">
                        <div class="unionTabList flex">
                            <div :class="['unionTab',tabActive == index ? 'unionTabOn' : '']" v-for="(item,index) in tabData" :key="index" @click="tabTap(index)">{{ item.title }}</div>
                        </div>
                        <el-input v-model="searchKey" placeholder="请输入内容" class="search"></el-input>
                    </div>
                    <div class="unionList flex" v-if="terrData[treeActive].name == 'duanju' || terrData[treeActive].name == 'xingtuxs'">
                        <div class="shortItem" v-for="(item,index) in unionData.list" :key="index">
                            <div class="shortImgBox">
                                <el-image :src="item.img" fit="cover" class="shortImg"></el-image>
                                <el-image :src="item.icon1" fit="cover" class="shortIcon"></el-image>
                                <el-image :src="item.icon2" fit="cover" class="shortSign"></el-image>
                            </div>
                            <div class="shortBox">
                                <div class="shortTitle" :title="item.title">{{ item.title }}</div>
                                <div class="theater">{{ item.cate_name }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="unionList flex">
                        <div class="unionItem" v-for="(item,index) in unionData.list" :key="index">
                            <div class="imgBox">
                                <el-image :src="item.img" fit="cover" class="itemImg"></el-image>
                                <div class="itemId">活动ID:{{ item.id }}</div>
                            </div>
                            <div class="itemBox">
                                <div class="title" :title="item.title">{{ item.title }}</div>
                                <div class="commission">佣金<span class="commissionNum">{{ item.yongjin }}</span></div>
                                <div class="time" :title="item.jiesuan">结算时间:{{ item.jiesuan }}</div>
                                <div class="spb">
                                    <div class="unionBtn">活动说明</div>
                                    <div class="unionBtn unionBtnOn" @click="unionBtnTap(item.id)">立即推广</div>
                                </div>
                            </div>
                        </div>
                        <div class="pageBox align">
                            <el-pagination background :current-page="page" layout="prev,pager,next,jumper" :page-size="35" :total="unionData.total" @current-change="currentPage"></el-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="unionBottom column">
                <div class="bindBox between">
                    <div class="align">
                        <el-image :src="require('@/assets/icon/bind01.png')" fit="cover" class="bindIcon"></el-image>
                        <div>
                            <div class="bindTitle">绑定手机号</div>
                            <div class="bindTips">您已绑定手机号130****3696,可以作为登录账号使用</div>
                        </div>
                    </div>
                    <div class="bindBtn" @click="bindPhone = true">更换绑定</div>
                </div>
                <div class="bindBox between">
                    <div class="align">
                        <el-image :src="require('@/assets/icon/bind02.png')" fit="cover" class="bindIcon"></el-image>
                        <div>
                            <div class="bindTitle">绑定微信</div>
                            <div class="bindTips">您已绑定微信号</div>
                        </div>
                    </div>
                    <div class="bindBtn">更换微信</div>
                </div>
            </div> -->
            <!-- <div class="unionBottom column" style="overflow-x: scroll;">
                <join></join>
            </div> -->
        </div>
        <!-- 抽屉 -->
        <el-drawer title="立即推广" size="1100" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
            <div class="promotionContent" v-if="proTabData.length > 0">
                <div class="proItem align" style="margin-bottom: 28px;">
                    <div class="linkName">渠道标识：</div>
                    <el-input v-model="sign" placeholder="请输入渠道标识" class="signIpt"></el-input>
                    <div class="signBtn" @click="sign = ''">更换</div>
                </div>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane v-for="(item,index) in proTabData" :key="index" :label="item.name" :name="'tab' + index" >
                        <div v-if="proTabData[active].data.haibao && proTabData[active].data.haibao != ''">
                            <div class="center">
                                <el-image :src="proTabData[active].data.haibao" fit="cover" class="posterImg"></el-image>
                            </div>
                            <div class="posterBtn center">
                                <div class="copyBtn" style="margin-right: 24px;" @click="linkBtnTap(proTabData[active].data.haibao)">复制海报</div>
                                <div class="loadBtn" @click="loadBtnTap(proTabData[active].data.haibaocode)">下载海报</div>
                            </div>
                        </div>
                        <div class="proItem align" v-if="proTabData[active].data.changlian && proTabData[active].data.changlian != ''">
                            <div class="linkName">长链接：</div>
                            <div class="link">{{ proTabData[active].data.changlian }}</div>
                            <div class="linkBtn" @click="linkBtnTap(proTabData[active].data.changlian)">复制</div>
                        </div>
                        <div class="proItem align" v-if="proTabData[active].data.duanlian && proTabData[active].data.duanlian != ''">
                            <div class="linkName">短链接：</div>
                            <div class="link">{{ proTabData[active].data.duanlian }}</div>
                            <div class="linkBtn" @click="linkBtnTap(proTabData[active].data.duanlian)">复制</div>
                        </div>
                        <div class="proItem align" v-if="proTabData[active].data.wenan && proTabData[active].data.wenan != ''">
                            <div class="linkName">推广文案：</div>
                            <div class="link">{{ proTabData[active].data.wenan }}</div>
                            <div class="linkBtn" @click="linkBtnTap(proTabData[active].data.wenan)">复制</div>
                        </div>
                        <!-- <div class="proItem align">
                            <div class="linkName">海报：</div>
                            <div class="link">https://ut-static.udache.com/t-painter/toggle/painter/base/1719394860081</div>
                            <div class="linkBtn">复制</div>
                        </div>
                        <div class="proItem align">
                            <div class="linkName">公众号回复代码：</div>
                            <div class="link">https://kur102.cn/7n22uX</div>
                            <div class="linkBtn">复制</div>
                        </div> -->
                        <div class="proItem flex" v-if="proTabData[active].data.code && proTabData[active].data.code != ''">
                            <div class="linkName">二维码：</div>
                            <el-image :src="proTabData[active].data.code" fit="cover" class="proCode"></el-image>
                            <div class="codeBtn">
                                <div class="loadBtn" @click="loadBtnTap(proTabData[active].data.basecode)">下载二维码</div>
                                <div class="copyBtn" @click="linkBtnTap(proTabData[active].data.code)">复制二维码</div>
                            </div>
                        </div>
                        <div class="againBtn" @click="unionBtnTap(drawerId)">重新生成</div>
                        <div class="againTipsBox align">
                            <el-image :src="require('@/assets/icon/tips.png')" fit="cover" class="againTipsIcon"></el-image>
                            <div class="againTips">重新生成后原链接依然有效，不会失效，请放心推广！！</div>
                        </div>
                    </el-tab-pane>
            </el-tabs>
            </div>
        </el-drawer>
        <!-- 手机号弹窗 -->
        <el-dialog title="绑定手机号" :center="true" :visible.sync="bindPhone" width="702px" :before-close="handleClose">
            <div class="bindPhoneBox">
                <div class="bindPhoneItem align">
                    <div class="bpTitle"><span class="bpIcon">*</span>新手机号码：</div>
                    <el-input v-model="newPhone" :maxlength="11" placeholder="输入要绑定的手机号码" class="bpIpt"></el-input>
                </div>
                <div class="bindPhoneItem align">
                    <div class="bpTitle"><span class="bpIcon">*</span>验证码：</div>
                    <el-input v-model="code" placeholder="输入验证码" class="bpCodeIpt"></el-input>
                    <div class="dpCodeBtn">获取验证码</div>
                </div>
                <div class="bindPhoneItem align">
                    <div class="bpTitle"><span class="bpIcon">*</span>登录密码：</div>
                    <el-input v-model="pass" placeholder="输入登录密码" class="bpIpt"></el-input>
                </div>
                <div class="bindPhoneItem align">
                    <div class="bpTitle"><span class="bpIcon">*</span>确认登录密码：</div>
                    <el-input v-model="passAgain" placeholder="再次确认登录密码" class="bpIpt"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="bindPhone = false">确认绑定</el-button>
            </span>
        </el-dialog>
        <!-- 成为合伙人弹窗 -->
        <div class="expirePopup" v-if="expireShow">
            <el-image :src="require('@/assets/image/expire.png')" fit="cover" class="expire"></el-image>
            <el-image :src="require('@/assets/icon/loginClose.png')" fit="cover" class="expireClose" @click="expireShow = false"></el-image>
        </div>
    </div>
</template>
<script>
    import join from '@/components/join.vue'
    import useClipboard from "vue-clipboard3";
    const { toClipboard } = useClipboard();
    export default{
        components: {
            join
        },
        data(){
            return {
                userId: 0,
                userData: {},
                logoImg: '',
                leftTab: [],
                oneActive: 0,
                terrData: [],
                treeActive: 0,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                tabData: [],
                tabActive: 0,
                searchKey: '',
                page: 1,
                unionData: {},
                drawer: false,
                direction: 'rtl',
                sign: '1056',
                drawerId: '',
                proTabData: [],
                active: 0,
                activeName: 'tab0',
                cityData: [],
                cityOne: 0,
                cityTwo: 0,
                goodSearchKey: '',
                goodsCateData: [],
                goodsCateActive: 0,
                goodsData: {
                    list: [],
                    cursor: ''
                },
                expand: true,
                bindPhone: false,
                newPhone: '',
                code: '',
                pass: '',
                passAgain: '',
                expireShow: false
            }
        },
        mounted(){
            this.userId = localStorage.getItem("userId") || 0
            if(!this.userId){
                this.$router.push({ path:'/login/login' })
                return
            }
            this.getAppLogo()
            this.getUserData()
            this.getLeft()
            this.getOne()
        },
        methods: {
            // 网站logo
            getAppLogo(){
                this.request.get("api/index/pclogo",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.logoImg = res.data
                })
            },
            // 获取头像昵称
            getUserData(){
                this.request.get("api/user/userInfo",{
                    params:{
                        userid: this.userId
                    }
                })
                .then(res=>{
                    this.userData = res.data
                })
            },
            // 获取左侧
            getLeft(){
                this.request.get("api/index/index",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.leftTab = res.data
                })
            },
            // 获取一级分类
            getOne(){
                this.request.get("api/index/onecate",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.terrData = res.data
                    if(res.data[this.treeActive].name == 'bendi'){
                        this.getCity()
                    }else{
                        this.getTwo()
                    }
                })
            },
            // 获取二级分类
            getTwo(){
                this.request.get("api/index/twocate",{
                    params:{
                        cateid: this.terrData[this.treeActive].id
                    }
                })
                .then(res=>{
                    this.tabData = res.data
                    this.getUnion()
                })
            },
             // 获取商品列表
             getUnion(){
                this.request.get("api/index/getinfos",{
                    params:{
                        type: this.terrData[this.treeActive].name,
                        cateid: `${this.terrData[this.treeActive].id},${this.tabData[this.tabActive].id}`,
						page: this.page,
						pagesize: '35'
                    }
                })
                .then(res=>{
                    this.unionData = res.data
                })
            },
            handleNodeClick(data,node) {
                console.log(data,node);
            },
            // 一级分类切换
            twoBoxTap(e){
                this.page = 1
                this.tabActive = 0
                this.treeActive = e
                if(this.terrData[this.treeActive].name == 'bendi'){
                    this.getCity()
                }else{
                    this.getTwo()
                }
            },
            // 二级分类切换
            tabTap(e){
                this.page = 1
                this.tabActive = e
                this.getUnion()
            },
            // 翻页
            currentPage(e){
                this.page = e
                this.getUnion()
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => {});
            },
            handleClick(tab, event) {
                console.log(tab, event);
                this.active = tab.index
            },
            // 获取城市
            getCity(){
                this.request.get("api/bdgoods/city",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.cityData = res.data
                    this.getGoodsCate()
                })
            },
            // 获取本地生活分类
            getGoodsCate(){
                this.request.get("api/bdgoods/cate",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.goodsCateData = res.data
                    this.getGoods()
                })
            },
            // 获取本地生活商品
            getGoods(){
                this.request.get("api/bdgoods/goodslist",{
                    params:{
                        cursor: this.goodsData.cursor,
                        category_id: this.goodsCateData[this.goodsCateActive].val,
                        count: 20,
                        keyword: this.goodSearchKey,
                        city_code: this.cityData[this.cityOne].children[this.cityTwo].val
                    }
                })
                .then(res=>{
                    this.goodsData.list.push(...res.data.list)
                    this.goodsData.cursor = res.data.cursor
                })
            },
            load () {
                this.getGoods()
            },
            // 本地生活重置封装
            getGoodsInitial(){
                this.goodsData.list = []
                this.goodsData.cursor = ''
                this.getGoods()
            },
            // 省份切换
            cityOneTap(e){
                this.cityTwo = 0
                this.cityOne = e
                this.getGoodsInitial()
            },
            // 城市切换
            cityTwoTap(e){
                this.cityTwo = e
                this.getGoodsInitial()
            },
            // 分类切换
            goodsCateTap(e){
                this.goodsCateActive = e
                this.getGoodsInitial()
            },
            // 演唱会活动说明
            smBtnTap(){
                this.$alert(this.unionData.list[0].xiangmuyaoqiu, '活动说明', {
                    confirmButtonText: '确定',
                    callback: action => {
                        
                    }
                });
            },
            // 推广
            unionBtnTap(e){
                this.request.get("api/partner/open",{
                    params:{
                        userid: this.userId
                    }
                })
                .then(res=>{
                    if(res.data == '1'){
                        this.expireShow = true
                    }else{
                        if(this.terrData[this.treeActive].name == 'liuliangka' || this.terrData[this.treeActive].name == 'info' || this.terrData[this.treeActive].name == 'yanchanghui' || this.terrData[this.treeActive].name == 'travelcard'){
                            if(this.sign == ''){
                                this.$message({
                                    message: '渠道标识不能为空',
                                    type: 'warning'
                                });
                                return
                            }
                            this.drawerId = e
                            this.request.get("api/link/infodetail",{
                                params:{
                                    userid: this.userId,
                                    id: e,
                                    type: this.terrData[this.treeActive].name,
                                    mark: this.sign,
                                    pc: 1
                                }
                            })
                            .then(res=>{
                                this.proTabData = res.data
                                this.drawer = true
                            })
                        }
                    }
                })
            },
            // 复制文案
            linkBtnTap(e){
                toClipboard(e);
                this.$message({
                    message: '复制成功',
                    type: "success",
                });
            },
            // 下载图片
            loadBtnTap(e){
                // 创建一个隐藏的a标签，并设置下载属性
                var link = document.createElement('a');
                link.href = e;
                link.download = 'image.png';

                // 模拟点击下载链接
                link.click();
            }
        }
    }
</script>
<style lang="less" scoped>
    .unionContent{
        width: 100vw;
        height: 100vh;
        background: #F2F4F7;
        display: flex;
        .treeBox{
           width: 304px;
           height: 100vh;
           margin-right: 24px;
           .treeOne{
                width: 64px;
                padding-top: 114px;
                height: calc(100vh - 114px);
                background: #000;
                overflow-y: scroll;
                scrollbar-width: none;
                .oneItem{
                    width: 54px;
                    height: 54px;
                    border-radius: 4px;
                    margin-bottom: 16px;
                    cursor: pointer;
                    .oneIcon{
                        width: 24px;
                        height: 24px;
                        margin-top: 4px;
                    }
                }
                .oneItemOn{
                    background: #FF601C;
                }
                .oneName{
                    font: 14px/18px "Microsoft YaHei";
                    color: #fff;
                    margin-top: 3px;
                }
           }
           /deep/ .el-tree-node__content{
                height: 56px;
                margin-bottom: 8px;
                border-radius: 4px;
            }
           .treeTwoBox{
                width: 240px;
                height: 100vh;
                background: #fff;
                .uniLogo{
                    width: auto;
                    height: 57px;
                    margin-top: 28px;
                }
                .treeTwo{
                    width: 208px;
                    padding: 30px 0;
                    height: calc(100vh - 145px);
                    overflow-y: scroll;
                    scrollbar-width: none;
                    .twoBox{
                        width: 184px;
                        height: 56px;
                        padding: 0 12px;
                        border-radius: 4px;
                        cursor: pointer;
                        .twoIcon{
                            width: 24px;
                            height: 24px;
                            margin: 0;
                        }
                        .twoName{
                            font: 14px/18px "Microsoft YaHei";
                            color: #161825;
                            margin-left: 8px;
                        }
                        .twoNameOn{
                            color: #FF601C;
                        }
                    }
                }
           }
        }
        .unionBox{
            // flex: 1;
            width: calc(100vw - 328px);
            height: 100vh;
            .unionTop{
                padding: 25px 0;
                .foldBox{
                    width: 53px;
                    height: 53px;
                    background: #fff;
                    border-radius: 8px;
                    cursor: pointer;
                    .fold{
                        width: 24px;
                        height: 24px;
                    }
                }
                .floatList{
                    padding: 0 10px;
                    height: 52px;
                    border-radius: 26px;
                    background: #fff;
                    .floatBox{
                        padding: 0 10px;
                        height: 34px;
                        border-radius: 17px;
                        cursor: pointer;
                        .floatIcon{
                            width: 24px;
                            height: 24px;
                        }
                        .floatName{
                            font: 14px/18px "Microsoft YaHei";
                            color: #161825;
                            margin-left: 2px;
                        }
                    }
                    .line{
                        width: 1px;
                        height: 12px;
                        background: #EBEBEB;
                        margin: 0 8px;
                    }
                    .head{
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        margin-left: 26px;
                    }
                }
            }
            .concert{
                width: 100%;
                height: calc(100vh - 103px);
                background: #fff;
                border-radius: 4px;
                overflow-y: scroll;
                .concertImg{
                    width: 100%;
                    height: 202px;
                    overflow: visible;
                }
                .concertContent{
                    width: 76%;
                    .concertBox{
                        min-width: 396px;
                        padding: 0 23px;
                        margin-top: 46px;
                        .concertTitle{
                            font: 30px/40px "Microsoft YaHei";
                            color: #161825;
                        }
                        .concertTips{
                            font: 14px/24px "Microsoft YaHei";
                            color: #73727A;
                            margin-top: 12px;
                        }
                        .concertComm{
                            font: 14px/26px "Microsoft YaHei";
                            color: #161825;
                            margin-top: 12px;
                            .concertCommNum{
                                font: bold 20px/26px "Microsoft YaHei";
                                color: #FF601C;
                                padding-left: 3px;
                            }
                        }
                        .concertBtnBox{
                            margin-top: 16px;
                            .smBtn{
                                width: 102px;
                                height: 38px;
                                border-radius: 4px;
                                border: 1px solid #E6E6E6;
                                font: bold 14px/38px "Microsoft YaHei";
                                color: #161825;
                                text-align: center;
                                cursor: pointer;
                            }
                            .tgBtn{
                                width: 104px;
                                height: 40px;
                                background: #FF601C;
                                border-radius: 4px;
                                font: bold 14px/40px "Microsoft YaHei";
                                color: #fff;
                                text-align: center;
                                margin-left: 16px;
                                cursor: pointer;
                            }
                        }
                    }
                }
                .concertList{
                    width: 76%;
                    min-width: 396px;
                    margin: 28px 0;
                    .concertItem{
                        width: 270px;
                        height: 144px;
                        padding: 18px 40px;
                        border-radius: 4px;
                        border: 1px solid #EBEBEB;
                        margin: 16px 23px;
                        .ciImg{
                            width: 56px;
                            height: 56px;
                        }
                        .ciTitle{
                            font: 18px/24px "Microsoft YaHei";
                            color: #161825;
                            margin-top: 8px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .ciTips{
                            font: 14px/20px "Microsoft YaHei";
                            color: #AAA5A2;
                            margin-top: 8px;
                            overflow:hidden;
                            text-overflow:ellipsis;
                            display:-webkit-box;
                            -webkit-line-clamp:2;
                            -webkit-box-orient:vertical;
                        }
                    }
                }
            }
            .unionBottom{
                width: 100%;
                height: calc(100vh - 103px);
                background: #fff;
                border-radius: 4px;
                .unionTabBox{
                    padding: 14px 32px 0 32px;
                    border-bottom: 1px solid #EBEBEB;
                    .unionTabList{
                        margin-bottom: -1px;
                        .unionTab{
                            font: 16px/56px "Microsoft YaHei";
                            margin-left: 56px;
                            padding-bottom: 1px;
                            cursor: pointer;
                            &:first-child{
                                margin: 0;
                            }
                        }
                        .unionTabOn{
                            color: #FF601C;
                            border-bottom: 1px solid #FF601C;
                            padding: 0;
                        }
                    }
                    .search{
                        width: 320px;
                        height: 40px;
                        /deep/ .el-input__inner {
                            border: none;
                            background: #F5F5F5;
                            border-radius: 20px;
                            padding: 0 24px;
                        }
                    }
                }
                .unionList{
                    padding: 24px;
                    max-height: calc(100vh - 224px);
                    overflow-y: scroll;
                    scrollbar-width: none;
                    position: relative;
                    .shortItem{
                        width: 237px;
                        height: 396px;
                        background: #fff;
                        box-shadow: 0px 2px 22px 0px rgba(0,0,0,0.05);
                        border-radius: 8px;
                        margin: 7px;
                        .shortImgBox{
                            width: 237px;
                            height: 321px;
                            position: relative;
                            .shortImg{
                                width: 237px;
                                height: 321px;
                                border-radius: 8px 8px 0 0;
                            }
                            .shortIcon{
                                width: 41px;
                                height: 22px;
                                position: absolute;
                                top: 8px;
                                left: 8px;
                            }
                            .shortSign{
                                width: 20px;
                                height: 20px;
                                position: absolute;
                                top: 8px;
                                right: 12px;
                            }
                        }
                        .shortBox{
                            padding: 0 16px;
                            .shortTitle{
                                font: bold 16px/22px "Microsoft YaHei";
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                margin-top: 10px;
                            }
                            .theater{
                                font: 14px/20px "Microsoft YaHei";
                                color: #8D8D8D;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                margin-top: 8px;
                            }
                        }
                    }
                    .unionItem{
                        width: 237px;
                        height: 270px;
                        background: #fff;
                        box-shadow: 0px 2px 22px 0px rgba(0,0,0,0.05);
                        border-radius: 8px;
                        margin: 7px;
                        .imgBox{
                            width: 237px;
                            height: 120px;
                            position: relative;
                            .itemImg{
                                width: 237px;
                                height: 120px;
                                border-radius: 8px 8px 0 0;
                            }
                            .itemId{
                                padding: 0 6px;
                                height: 24px;
                                background: rgba(0,0,0,0.45);
                                border-radius: 0 8px 0 0;
                                font: 14px/24px "Microsoft YaHei";
                                color: #fff;
                                position: absolute;
                                left: 0;
                                bottom: 0;
                            }
                        }
                        .itemBox{
                            padding: 10px 16px 16px 16px;
                            .title{
                                font: bold 16px/22px "Microsoft YaHei";
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                            .commission{
                                font: 14px/26px "Microsoft YaHei";
                                color: #161825;
                                margin-top: 10px;
                                .commissionNum{
                                    font: bold 20px/26px "Microsoft YaHei";
                                    color: #ff601c;
                                    margin-left: 4px;
                                }
                            }
                            .time{
                                font: 12px/16px "Microsoft YaHei";
                                color: #73727a;
                                margin: 4px 0 12px 0;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                            .unionBtn{
                                width: 96px;
                                height: 30px;
                                border-radius: 4px;
                                border: 1px solid #E6E6E6;
                                font: 14px/32px "Microsoft YaHei";
                                color: #161825;
                                text-align: center;
                                cursor: pointer;
                            }
                            .unionBtnOn{
                                border: 1px solid #ff601c;
                                color: #ff601c;
                            }
                        }
                    }
                    .pageBox{
                        padding: 0 32px;
                        height: 60px;
                        background: rgba(255,255,255,0.8);
                        border-radius: 30px;
                        box-shadow: 0 2px 22px 0 rgba(0,0,0,0.1);
                        position: fixed;
                        right: 24px;
                        bottom: 20px;
                    }
                }
                .groupBox{
                    height: calc(100vh - 103px);
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    .expandBox{
                        width: 96px;
                        height: 42px;
                        background: rgba(255,255,255,0.8);
                        box-shadow: 0 2px 22px 0 rgba(0,0,0,0.1);
                        border-radius: 21px;
                        position: absolute;
                        top: 16px;
                        right: 16px;
                        z-index: 2;
                        cursor: pointer;
                        .expandName{
                            font: 14px/42px "Microsoft YaHei";
                            color: #161825;
                            padding-right: 4px;
                        }
                        .expandIcon{
                            width: 16px;
                            height: 16px;
                        }
                    }
                    .groupScreen{
                        padding: 24px 24px 16px 24px;
                        .screenBox{
                            padding: 8px 0;
                            .screenTitle{
                                width: 88px;
                                font: 14px/48px "Microsoft YaHei";
                                color: #73727A;
                                text-align: right;
                            }
                            .screenList{
                                flex: 1;
                                .screen{
                                    padding: 0 12px;
                                    height: 32px;
                                    border-radius: 4px;
                                    margin: 8px;
                                    font: 14px/32px "Microsoft YaHei";
                                    color: #161825;
                                    cursor: pointer;
                                    &:hover{
                                        background: #FF601C;
                                        color: #fff !important;
                                    }
                                }
                                .screenOn{
                                    background: #FF601C;
                                    color: #fff !important;
                                }
                            }
                            .goodSearch{
                                width: 320px;
                                height: 40px;
                                margin: 0 12px 0 8px;
                            }
                            .goodSearchBtn{
                                width: 76px;
                                height: 40px;
                                border-radius: 4px;
                                border: 1px solid #FF601C;
                                font: 14px/40px "Microsoft YaHei";
                                text-align: center;
                                color: #FF601C;
                                cursor: pointer;
                            }
                        }
                    }
                    .groupList{
                        flex: 1;
                        height: 100%;
                        margin-top: 16px;
                        .group{
                            width: 206px;
                            height: 338px;
                            padding: 16px;
                            background: #fff;
                            box-shadow: 0 2px 22px 0 rgba(0,0,0,0.05);
                            border-radius: 8px;
                            margin: 8px;
                            .groupImg{
                                width: 206px;
                                height: 206px;
                                border-radius: 8px;
                            }
                            .groupTitle{
                                font: bold 16px/22px "Microsoft YaHei";
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                margin-top: 10px;
                            }
                            .groupCommission{
                                font: 14px/26px "Microsoft YaHei";
                                color: #161825;
                                margin: 8px 0 44px 0;
                                .groupCommissionNum{
                                    font: bold 20px/26px "Microsoft YaHei";
                                    color: #ff601c;
                                    margin-left: 4px;
                                }
                            }
                            .price{
                                font: bold 20px/26px "Microsoft YaHei";
                                color: #ff601c;
                            }
                            .origin{
                                font: 14px/18px "Microsoft YaHei";
                                color: #73727A;
                                padding: 0 4px;
                                margin-top: 6px;
                                text-decoration-line: line-through;
                            }
                            .discount{
                                padding: 0 2px;
                                height: 22px;
                                background: #FFF2F2;
                                border-radius: 2px;
                                font: 14px/22px "Microsoft YaHei";
                                color: #F34646;
                                margin-top: 4px;
                            }
                        }
                    }
                }
                .bindBox{
                    width: calc(100% - 64px);
                    height: 128px;
                    border-radius: 8px;
                    border: 1px solid #EBEBEB;
                    margin: 16px 32px 0 32px;
                    &:first-child{
                        margin-top: 32px;
                    }
                    &:last-child{
                        margin-bottom: 32px;
                    }
                    .bindIcon{
                        width: 64px;
                        height: 64px;
                        margin: 0 8px 0 28px;
                    }
                    .bindTitle{
                        font: bold 16px/22px "Microsoft YaHei";
                    }
                    .bindTips{
                        font: 13px/17px "Microsoft YaHei";
                        color: #73727A;
                        margin-top: 8px;
                    }
                    .bindBtn{
                        width: 112px;
                        height: 44px;
                        border-radius: 4px;
                        border: 1px solid #FF601C;
                        font: 16px/44px "Microsoft YaHei";
                        color: #FF601C;
                        text-align: center;
                        margin-right: 38px;
                        cursor: pointer;
                    }
                }
            }
        }
        .promotionContent{
            width: 1000px;
            padding: 0 32px;
            .proItem{
                margin-top: 20px;
                .linkName{
                    width: 156px;
                    font: 14px/42px "Microsoft YaHei";
                    color: #73727A;
                    text-align: right;
                }
                .signIpt{
                    width: 228px;
                    height: 40px;
                    margin: 0 12px 0 8px;
                }
                .signBtn{
                    font: 14px/42px "Microsoft YaHei";
                    color: #FF601C;
                    cursor: pointer;
                }
                .link{
                    width: 448px;
                    padding: 10px 12px;
                    border-radius: 4px;
                    border: 1px solid #E4E7ED;
                    margin: 0 16px 0 8px;
                    font: 14px/22px "Microsoft YaHei";
                    color: #161825;
                }
                .linkBtn{
                    width: 76px;
                    height: 40px;
                    border-radius: 4px;
                    border: 1px solid #FF601C;
                    font: 14px/40px "Microsoft YaHei";
                    color: #FF601C;
                    text-align: center;
                    cursor: pointer;
                }
                .proCode{
                    width: 104px;
                    height: 104px;
                    margin: 0 12px 0 8px;
                }
                .codeBtn{
                    padding: 6px 0;
                    height: 92px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }
            }
            .loadBtn{
                padding: 0 24px;
                height: 40px;
                border-radius: 4px;
                border: 1px solid #FF601C;
                font: 14px/40px "Microsoft YaHei";
                color: #FF601C;
                cursor: pointer;
            }
            .copyBtn{
                padding: 0 24px;
                height: 40px;
                border-radius: 4px;
                border: 1px solid #E6E6E6;
                font: 14px/40px "Microsoft YaHei";
                color: #161825;
                cursor: pointer;
            }
            .againBtn{
                width: 104px;
                height: 40px;
                background: #FF601C;
                border-radius: 4px;
                font: 14px/40px "Microsoft YaHei";
                color: #fff;
                text-align: center;
                cursor: pointer;
                margin: 72px auto 20px auto;
            }
            .againTipsBox{
                width: 100%;
                height: 36px;
                background: #FFF7F3;
                border-radius: 4px;
                margin-bottom: 30px;
                .againTipsIcon{
                    width: 16px;
                    height: 16px;
                    margin-left: 16px;
                }
                .againTips{
                    font: 14px/20px "Microsoft YaHei";
                    color: #FF601C;
                    margin-left: 8px;
                }
            }
            .posterImg{
                width: 346px;
                height: 630px;
                margin: 24px auto;
            }
            .posterBtn{
                margin-bottom: 30px;
            }
        }
        .bindPhoneBox{
            .bindPhoneItem{
                margin-top: 20px;
                &:first-child{
                    margin: 0;
                }
                .bpTitle{
                    width: 130px;
                    font: 14px/20px "Microsoft YaHei";
                    color: #73727A;
                    text-align: right;
                    .bpIcon{
                        color: #F34646;
                    }
                }
                .bpIpt{
                    width: 440px;
                    height: 40px;
                    border-radius: 4px;
                    margin-left: 8px;
                }
                .bpCodeIpt{
                    width: 228px;
                    height: 40px;
                    border-radius: 4px;
                    margin-left: 8px;
                }
                .dpCodeBtn{
                    width: 118px;
                    height: 40px;
                    border-radius: 4px;
                    border: 1px solid #FF601C;
                    font: 14px/40px "Microsoft YaHei";
                    color: #FF601C;
                    text-align: center;
                    margin-left: 12px;
                }
            }
        }
        .expirePopup{
            width: 100vw;
            height: 100vh;
            background: rgba(0,0,0,0.5);
            position: fixed;
            left: 0;
            top: 0;
            z-index: 99;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .expire{
                width: 482px;
                height: 606px;
                cursor: pointer;
            }
            .expireClose{
                width: 36px;
                height: 36px;
                cursor: pointer;
            }
        }
    }
</style>